import { render, staticRenderFns } from "./PCFull.vue?vue&type=template&id=cf735772&scoped=true"
import script from "./PCFull.vue?vue&type=script&setup=true&lang=js"
export * from "./PCFull.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCFull.vue?vue&type=style&index=0&id=cf735772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf735772",
  null
  
)

export default component.exports